"use client"

import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { useTranslations } from "next-intl"
import { Dispatch, SetStateAction } from "react"
import NewText from "./NewText/NewText"
import { FormFailIcon, FormSuccessIcon } from "./icons"
import { sharedColors as colors } from "./theme/colors"

const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  text-align: center;
`
const StyledText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const StyledButton = styled(Button)`
  width: 263px;
  font-size: 18px;
  font-weight: 600;
  color: white;
  text-decoration: unset;
  height: 43px;
  padding: 7.5px 8px;
  background-color: #4969a2;
  border: 1px solid #000000;
  border-radius: 12.65px;
  letter-spacing: -0.01em;
  :hover {
    background-color: #4969a2;
  }
`

type Props = {
  state: "success" | "fail"
  setIsSubmitted: Dispatch<SetStateAction<boolean>>
  messages: any
  onClose?: any
}
function SuccessFailStateLanding({ state, setIsSubmitted }: Props) {
  const t = useTranslations("SuccessFailBox")
  const getMessage = () => {
    if (state === "success") {
      return t("successLanding")
    } else {
      return t("errorLanding")
    }
  }
  return (
    <StyledForm>
      {state === "success" ? (
        <FormSuccessIcon width={60} height={60} />
      ) : (
        <FormFailIcon width={60} height={60} />
      )}
      <StyledText>
        <NewText
          component={"p"}
          desktopFontSize={20}
          desktopLineHeight={"120%"}
          desktopFontWeight={"bold"}
          color={colors.black}
          maxWidth={"330px"}
        >
          {state === "success" ? t("successTitleLanding") : t("errorTitleLanding")}
        </NewText>
        <NewText
          component={"p"}
          desktopFontSize={16}
          desktopLineHeight={"normal"}
          desktopFontWeight={400}
          mobileLineHeight={"normal"}
          color={colors.black}
          maxWidth={"330px"}
        >
          {getMessage()}
        </NewText>
      </StyledText>
      {
        state === "fail" && (
          <StyledButton onClick={() => setIsSubmitted(false)}>{t("tryAgainLanding")}</StyledButton>
        )
      }
    </StyledForm >
  )
}

export default SuccessFailStateLanding
